import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";
import { Subscription } from 'rxjs';
import { LotteryService } from 'src/app/services';
// import { SplitText } from "gsap/SplitText";

@Component({
  selector: 'app-millionpakken-hero',
  templateUrl: './millionpakken-hero-spot.component.html',
  styleUrls: ['./millionpakken-hero-spot.component.scss']
})
export class MillionpakkenHeroComponent implements OnInit, OnDestroy {

  public showCounter = false;
  public countdownDate: Date;

  private lotterySubscription: Subscription;
  private router: Router;
  private readonly lotteryService: LotteryService;
  private salestopSubscription = new Subscription();

  public constructor(router: Router, lotteryService: LotteryService) { 
    this.router = router;
    this.lotteryService = lotteryService;
  }

  public ngOnInit(): void
  {
    this.isInUrgencyPeriod()
    this.animateHeader();
  }

  public animateHeader(): void
  {
    gsap.registerPlugin(SplitText);

    gsap.registerEffect({
      name: "pulse",
      effect: (targets, config) => {
        tl = gsap.timeline({repeat: 3, repeatDelay: 0.3 });
        tl.to(targets, { scale: 1.2, duration: 0.3, ease: "back.in(4)" })
          .to(targets, { scale: 1, duration: 0.3, ease: "back.out(4)" });
        return tl
      },
      defaults: {duration: 0.5},
      extendTimeline: true
    });
    
    var tl = gsap.timeline({repeat: -1, repeatDelay: 10});
    
    var mySplitChar = new SplitText("#splitit", {type:"chars"})
    var chars = mySplitChar.chars;

    gsap.set("#splitit", {transformOrigin:"center center"});
  
    tl.add("start");
    
    tl.fromTo(chars, {y: 1000, rotate: 90, opacity:0},
      { duration: 1, 
        stagger: 0.1,
        y: "random(0, 10)",
        rotate: "random(-10, 10, 5)",   
        opacity:1,  
        ease: "power4.inOut",
        })
      .from(".lodpakke", {autoAlpha:0, y: 1000, rotate: 45, ease: "expo.out"}, "-=0.8")
      .from(".sub", {autoAlpha:0}, ">")
      .from(".cta", {autoAlpha:0}, "-=0.3")
      .pulse(".pulse", "+=2")
    ; 
  }

  public isInUrgencyPeriod(): void
  {
      this.lotterySubscription = this.lotteryService.isInUrgencyPeriod().subscribe((isUrgency) => {
          this.showCounter = isUrgency;
          if(isUrgency === true){
            this.setCountdownDate();
          }
      });
  }

  public showPage(): void
  {
    this.router.navigate(['/lodder-til-salg']);
  }

  private setCountdownDate(): void
  {
    this.salestopSubscription = this.lotteryService.getSaleStop().subscribe((result) => {
      const seconds = parseInt(result.Seconds, 10) || 0;
      const minutes = parseInt(result.Minutes, 10) || 0;
      const hours = parseInt(result.Hours, 10) || 0;
      const days = parseInt(result.Days, 10) || 0;

      const x = new Date();
      x.setDate(x.getDate() + days);
      x.setHours(x.getHours() + hours);
      x.setMinutes(x.getMinutes() + minutes);
      x.setSeconds(x.getSeconds() + seconds);

      this.countdownDate = x; 
    });
  }

  public ngOnDestroy(): void
  {
    if(this.salestopSubscription){
      this.salestopSubscription.unsubscribe();
    }
    this.lotterySubscription.unsubscribe
  }
}
